import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {
	DeleteRefundProcedure,
	DeleteRefundProcedureParams,
} from 'domain/usecases/private/refund/request/delete-procedure';
import {RemoteRefundDeleteProcedure} from 'data/usecases/private/refund/request/remote-delete-procedure';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeDeleteRefundProcedure = (
	params: DeleteRefundProcedureParams,
): DeleteRefundProcedure =>
	new RemoteRefundDeleteProcedure(
		makeBFFApiUrl(
			`${RefundFlowEndPoints.protocols}/${params.protocolCode}/requests/${params.requestCode}/procedure/${params.procedureCode}/${params.sequentialProcedure}`,
		),
		makeAuthorizeHttpClientDecorator(),
	);
